import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6663397e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "admin-video-list" }
const _hoisted_2 = { class: "d-flex mb-56 justify-content-between" }
const _hoisted_3 = { class: "h4 text-primary mb-0" }
const _hoisted_4 = { class: "fw-normal" }
const _hoisted_5 = { class: "top-section d-flex align-items-center justify-content-between" }
const _hoisted_6 = { class: "document-type d-flex align-items-center flex-wrap col-8 col-md-6 col-xl-5 col-xxl-4" }
const _hoisted_7 = { class: "d-flex justify-content-end mb-20" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-add me-12"
}, null, -1))
const _hoisted_9 = { class: "video-container" }
const _hoisted_10 = { class: "tab-content" }
const _hoisted_11 = {
  id: "grid",
  "aria-labelledby": "grid-tab",
  class: "tab-pane active",
  role: "tabpanel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_treeselect = _resolveComponent("treeselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_admin_videos_grid = _resolveComponent("the-admin-videos-grid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('Listado de')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('vídeos')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_treeselect, {
          modelValue: _ctx.typeSelected,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.typeSelected) = $event)),
          "clear-value-text": _ctx.$t('Borrar categoría'),
          multiple: true,
          "no-options-text": _ctx.$t('No se han encontrado resultados'),
          "no-results-text": _ctx.$t('No se han encontrado resultados'),
          options: _ctx.categories,
          placeholder: _ctx.$t('Selecciona una categoría')
        }, null, 8, ["modelValue", "clear-value-text", "no-options-text", "no-results-text", "options", "placeholder"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.can('admin.video.store'))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            "aria-label": _ctx.$t('Añadir vídeo'),
            to: {name: 'admin.video.store'},
            class: "btn btn-secondary btn-icon btn-sm"
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('Añadir vídeo')), 1)
            ]),
            _: 1
          }, 8, ["aria-label", "to"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_the_admin_videos_grid, {
            status: _ctx.status,
            videos: _ctx.videos,
            onRefreshMedia: _ctx.loadVideos
          }, null, 8, ["status", "videos", "onRefreshMedia"])
        ])
      ])
    ])
  ]))
}